// extracted by mini-css-extract-plugin
module.exports = {"container":"WorkItem_container__p5ND3","thumbnail":"WorkItem_thumbnail__2B54v","roles":"WorkItem_roles__tAfOQ","title":"WorkItem_title__1wOQH"};